import React from 'react';
import { Checkbox } from 'material-ui';
import R from 'ramda';

const DaysOfWeek = ({ daysOfWeek, updateDaysOfWeek }) => {
  return (
    <div style={{ width: '350px', display: 'inline-block', zIndex: '0' }}>
      <div style={{ float: 'left', width: '170px', zIndex: '0' }}>
        {
          ['All', 'Monday', 'Tuesday', 'Wednesday'].map((day, index) => {
            const dayIndexInReducer = R.findIndex(R.equals(day), daysOfWeek);
            const checked = R.propEq('length', 7, daysOfWeek) || dayIndexInReducer > -1;
            return (
              <Checkbox
                checked={checked}
                onCheck={() => updateDaysOfWeek(!checked, day, dayIndexInReducer)}
                label={day}
                key={index}
                labelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
              />
            );
          })
        }
      </div>
      <div style={{ float: 'left', width: '170px' }}>
        {
          ['Thursday', 'Friday', 'Saturday', 'Sunday'].map((day, index) => {
            const dayIndexInReducer = R.findIndex(R.equals(day), daysOfWeek);
            const checked = R.propEq('length', 7, daysOfWeek) || dayIndexInReducer > -1;
            return (
              <Checkbox
                checked={checked}
                onCheck={() => updateDaysOfWeek(!checked, day, dayIndexInReducer)}
                label={day}
                key={index}
                labelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
              />
            );
          })
        }
      </div>
    </div>
  )
};

export default DaysOfWeek;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/days-of-week.jsx